import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "../../styles/removeVantcell.css?vue&type=style&index=0&lang=css"
import "../../styles/editor.css?vue&type=style&index=1&id=0b44ed3c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=2&id=0b44ed3c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=3&id=0b44ed3c&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b44ed3c"]])

export default __exports__